import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button } from '@material-ui/core';
import { Formik, Field, Form } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';

class AddPasswordForm extends Component {

  render() {
    return (
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .min(6, "Password needs to be at least 6 characters")
            .required('Required'),
          confirmPassword: Yup.string()
            .required('Required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
        })}
        onSubmit={(values, actions) => {
          this.props.onSubmit(values.password);
          actions.setSubmitting(false);
        }}
      >
        {() => (
          <Form>
            <Field component={TextField} margin="normal" fullWidth label="Password" variant="outlined" type="password" name="password" />
            <Field component={TextField} margin="normal" fullWidth label="Confrim password" variant="outlined" type="password" name="confirmPassword" />
            <Button size="large" type="submit" variant="contained" color="primary">Add password</Button>
          </Form>
        )}
      </Formik>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggingIn: state.authReducer.isLoggingIn,
    authError: state.authReducer.authError,
  };
}

export default connect(mapStateToProps)(AddPasswordForm);
